import mitt, {Handler} from "mitt";
import Pusher, {Channel} from "pusher-js";
import React, {createContext, useContext, useMemo} from "react";
import {config} from "../config/config.ts";

interface PusherContextType {
    pusher?: Pusher,

    subscribeTo(channel: string): Channel,

    unsubscribeFrom(channel: string): void,

    on(handler: Handler<any>): void,

    off(handler: Handler<any>): void,
}

export const pusherBus = mitt(); //useEventBus<string>('pusher_events');
pusherBus.on('pusher_event', function (event: any) {
    console.debug(`[pusherBus][${event.event}/${event.table}/${event.uid || ''}]`, event);
});

const PusherContext = createContext<PusherContextType>({} as any);

function PusherProvider({pusher, children}: { pusher: Pusher, children: any }) {
    const contextValue = useMemo<PusherContextType>(
        (): PusherContextType => ({
            pusher,
            subscribeTo(channel: string) {
                const channelFinal = channel + (config.isProduction() ? '' : `_${config.appEnv}`);
                console.debug(`[pusher] subscribing to ${channelFinal}`)
                return pusher.subscribe(channelFinal).bind('events', (dataRaw) => {
                    pusherBus.emit('pusher_event', dataRaw);
                });
            },
            unsubscribeFrom(channel: string) {
                const channelFinal = channel + (config.isProduction() ? '' : `_${config.appEnv}`);
                console.debug(`[pusher] unsubscribing from ${channelFinal}`)
                pusher.unsubscribe(channelFinal);
            },
            on(handler) {
                pusherBus.on('pusher_event', handler);
            },
            off(handler) {
                pusherBus.off('pusher_event', handler);
            },
        }),
        []
    );

    return (
        <PusherContext.Provider value={contextValue}>
            {children}
        </PusherContext.Provider>
    );
}

function usePusher() {
    const context = useContext(PusherContext);
    if (!context) {
        throw new Error("usePusher must be used within a PusherProvider");
    }

    return context;
}

export {PusherProvider, usePusher};
